import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { GlobalService } from 'src/app/_services/global.service';
import { PermissionCheckerService } from 'src/app/_services/permission-checker.service';

@Component({
  selector: 'app-pos-configuration',
  templateUrl: './pos-configuration.component.html',
  styleUrls: ['./pos-configuration.component.scss']
})
export class PosConfigurationComponent implements OnInit {
  items: MenuItem[] = []
  private readonly _globals = GlobalService
  isTabsLoading = true
  tabSkeletonWidths: string[] = ['9rem', '11rem', '13rem', '12rem', '10rem', '12rem', '11rem']

  activeItem: any = null

  constructor(
    public _permissionsCheckerService: PermissionCheckerService,
    private readonly _router: Router,
  ) { }

  ngOnInit(): void {
    void this.initializeTabs();
  }

  private async initializeTabs(): Promise<void> {
    this.isTabsLoading = true
    try {
      await this.buildTabs();
      this.ensureActiveItemIsVisible();
    } finally {
      this.isTabsLoading = false
    }
  }

  private async buildTabs(): Promise<void> {
    this.items = [
      {
        label: 'Invoice Configuration',
        visible: await this._permissionsCheckerService.isPermissionValid(['2019']),
      },
      {
        label: 'Printing Configuration',
        visible: await this._permissionsCheckerService.isPermissionValid(['2020']),
      },
      {
        label: 'Cashdrop Configuration',
        visible: await this._permissionsCheckerService.isPermissionValid(['2021']),
      },
      {
        label: 'Cashdrawer Configuration',
        visible: await this._permissionsCheckerService.isPermissionValid(['2022']),
      },
      {
        label: 'Security Configuration',
        visible: await this._permissionsCheckerService.isPermissionValid(['2023']),
      },
      {
        label: 'Secondary Screen Configuration',
        visible: await this._permissionsCheckerService.isPermissionValid(['2092']),
      },
      {
        label: 'Purchase Order',
        visible: await this._permissionsCheckerService.isPermissionValid(['2093']),
      },
      {
        label: 'Time Tracking Configuration',
        visible: await this._permissionsCheckerService.isPermissionValid(['2094']),
      },
    ];
  }

  private ensureActiveItemIsVisible(): void {
    const activeLabel = this.activeItem?.label;
    const matchedActiveItem = this.items.find((item) => item.label === activeLabel && item.visible !== false);
    this.activeItem = matchedActiveItem ?? this.items.find((item) => item.visible !== false) ?? null;
  }

  /** Business-setup's sales-channel fields (hasPOS/hasPOSLite — see business-setup-checklist
   *  component's sellInStore hydration, and the left-menu's 'Hardware' item, which gates the
   *  same way) — POS Configuration only applies once the in-person sales channel is enabled. */
  get hasInStoreSalesChannel(): boolean {
    const setup = this.currentBusinessSetup();
    if (!setup) return true;
    const hasPOS = setup.hasPOS ?? setup.HasPOS;
    const hasPOSLite = setup.hasPOSLite ?? setup.HasPOSLite;
    if (hasPOS === undefined && hasPOSLite === undefined) return true;
    return !!(hasPOS || hasPOSLite);
  }

  private currentBusinessSetup(): any {
    const fromGlobals = this._globals.userInfo?.businessSetup?.[0];
    if (fromGlobals) return fromGlobals;
    try {
      const raw = sessionStorage.getItem('business-Info');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  goToSalesChannelSetup(): void {
    this._router.navigate(['/app/business-setup']);
  }

  onTabItemClick(tab: any) {
    this.activeItem = tab.activeItem
  }
}
